'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var icons = {
  image: 'fa-file-image',
  pdf: 'fa-file-pdf',
  word: 'fa-file-word',
  powerpoint: 'fa-file-powerpoint',
  excel: 'fa-file-excel',
  csv: 'fa-file-csv',
  audio: 'fa-file-audio',
  video: 'fa-file-video',
  archive: 'fa-file-archive',
  code: 'fa-file-code',
  text: 'fa-file-alt',
  file: 'fa-file'
};
exports.default = icons;